<div>
  <form
    [formGroup]="filtroFormGroup"
    (ngSubmit)="filtrar()"
    class="bg-secondary p-4 rounded-lg border border-foreground space-y-4"
  >
    <div class="flex gap-3">
      <app-data-picker
        class="w-full"
        [range]="rangeData"
        (rangeChange)="onRangeChanged($event)"
      ></app-data-picker>
      <app-select
        placeholder="Tipo"
        class="w-full"
        formControlName="type"
        [options]="typeOptions"
      ></app-select>
      <app-select
        placeholder="Produto"
        class="w-full"
        formControlName="product"
        [options]="productOptions"
      ></app-select>
      <app-select
        placeholder="Resposta"
        class="w-full"
        formControlName="transactionResponse"
        [options]="transactionResponseOptions"
      ></app-select>
      <app-multi-text-input formControlName="pos"></app-multi-text-input>
    </div>
    <div class="flex justify-end">
      <app-button type="submit">Filtrar</app-button>
    </div>
  </form>
</div>
<app-loading [show]="loading"></app-loading>
@if (!loading) {
<app-table [columns]="columns" [data]="data"></app-table>
}
<app-pagination-component
  [totalItems]="total"
  [itemsPerPage]="itemsPerPage"
  [currentPage]="page"
  (pageChange)="onPageChange($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
>
  ></app-pagination-component
>
